<template>
  <img :class="{'beethoven-success': success, 'beethoven-fail': !success && failed}" :src="computedSrc" :width="computedWidth" :height="computedHeight" :style="style" @load="onLoad" @error="onError">
</template>

<script>
import { $ } from 'bits/jquery'
import { observeIntersection, canObserveIntersection } from 'bits/intersection'
const BLANK_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='

export default {
  props: {
    src: {
      type: String,
      default: BLANK_IMAGE
    },
    backgroundColor: String,
    width: Number,
    height: Number,
    postWidth: Number,
    postHeight: Number,
    lazy: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      success: false,
      failed: false,
      isVisible: !canObserveIntersection
    }
  },
  computed: {
    computedSrc () {
      if (!this.lazy || this.isVisible) {
        return this.src
      }
      return BLANK_IMAGE
    },
    computedWidth () {
      return this.postWidth || this.width
    },
    computedHeight () {
      return this.postHeight || this.height
    },
    style () {
      return {
        'background-color': this.backgroundColor,
        width: this.computedWidth + 'px',
        height: this.computedHeight + 'px'
      }
    }
  },
  mounted () {
    if (this.lazy && !this.isVisible) {
      observeIntersection(this.$el, (_) => {
        this.isVisible = true
      })
    }
  },
  methods: {
    triggerCustomEvent (element, eventName) {
      let event = new CustomEvent('Event', { bubbles: false, cancelable: true })
      element.dispatchEvent(event)
    },
    onLoad () {
      this.imageBackgroundColor = ''
      this.success = true
      $(this.$el).trigger('beethoven-load')
    },
    onError () {
      this.imageBackgroundColor = ''
      this.failed = true
      $(this.$el).trigger('beethoven-error')
    }
  }
}
</script>
